import { CompanyRiskScoreWebComponent } from './component/CompanyRiskScoreWebComponent';
import { WEB_COMPONENT_WIDGET_COMPANY_RISK_SCORE } from '../webcomponents.constants';

export { CompanyRiskScoreWebComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_COMPANY_RISK_SCORE, CompanyRiskScoreWebComponent);
